
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LinkedinIconCustom extends Vue {
  @Prop({ default: '#ffffff' }) filled!: string;
}
